export const TEXTS = {
  TITLE: 'Переименовать группу адресов',
  INPUT_PLACEHOLDER: 'Например, экраны над кассой',
  SAVE_BUTTON_TEXT: 'Сохранить',
  NOTIFICATION_SUCCESS_TEXT: 'Группа адресов переименована',
  NOTIFICATION_ERROR_TOO_LONG_TEXT: 'Максимальная длина названия группы адресов - 128 символов',
};
